module.exports = __webpack_public_path__ + "img/up13.3af1151e.png";